export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,3}$/g;
// Minimum eight chars, at least one uppercase, one lowercase and one number
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const zipCodeRegex = /^(?:0[1-9]\d{3}|[1-9]\d{4})$/;
